import '@updater-components/fa-icon';
import React from 'react';
import { render } from 'react-dom';
import c from './index.module.css';
import { track as _track, CLICK } from '@updater-core/lib/tracker';
import { snakeCase } from 'lodash-es';

const track = (event) => {
  _track({
    verb: CLICK,
    object: snakeCase(event),
    segmentEventName: `${CLICK} ${event}`,
  });
};

const Link = ({ excludeLinkCodes, ...link }) => (
  <>
    {!excludeLinkCodes.includes(link.code) && (
      <li>
        <a
          href={link.href}
          className={`${c.categoryLink} ${c.fadeIn}`}
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          onClick={() => track(link.event)}
        >
          {link.name}
        </a>
      </li>
    )}
  </>
);

const SocialLink = (link) => (
  <>
    <a
      href={link.href}
      className={`${c.socialIcon} ${c.fadeIn} ${c.pop}`}
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      onClick={() => track(link.event)}
    >
      <upd-fa-icon name={link.icon} type="brand" class={c.socialLogo} />
    </a>
  </>
);

const Footer = ({
  year = new Date().getFullYear(),
  excludeLinkCodes = [],
  categories = [],
  legal = [],
  madeWithLove,
  showCopywrite,
  disclaimer,
}) => (
  <div className={c.container}>
    <div className={c.categories}>
      {categories.map((category) => (
        <div className={c.category} key={category.id}>
          {category.name && (
            <div className={c.categoryTitle}>
              <upd-fa-icon
                class={`${c.categoryIcon} ${c.pulse}`}
                name={category.icon}
                type={category.type}
              />
              <span>{category.name}</span>
            </div>
          )}
          {!category.name && <div className={c.categorySpace} />}

          {category.links && (
            <div className={c.row}>
              <ul>
                {category.links.map((link) => (
                  <Link
                    key={link.name}
                    excludeLinkCodes={excludeLinkCodes}
                    {...link}
                  />
                ))}
              </ul>
            </div>
          )}

          {category.socialLinks && (
            <div className={`${c.row} ${c.socialContainer}`}>
              {category.socialLinks.map((link) => (
                <SocialLink key={link.name} {...link} />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>

    <div className={`${c.row} ${c.legalRow}`}>
      <div className={c.legalContainer}>
        {showCopywrite && (
          <span className={c.copyright}>&copy; {year} Updater</span>
        )}
        {madeWithLove && (
          <a
            href="http://nytm.org/made-in-nyc"
            target="_blank"
            rel="noopener noreferrer"
            className={`${c.legalLinks} ${c.fadeIn}`}
            onClick={() => track('Footer Made In NYC Link')}
          >
            made with <upd-fa-icon name="heart" class={c.legalIcon} /> in NYC
          </a>
        )}
        {disclaimer && <span className={c.legalDisclaimer}>{disclaimer}</span>}

        {legal.map((link) => (
          <a
            key={link.text}
            href={link.href}
            // eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
            className={`${c.legalLinks} ${c.fadeIn}`}
            onClick={() => track(link.event)}
          >
            {link.text}
          </a>
        ))}
      </div>
    </div>
  </div>
);

export const createView = ({ container }) => {
  return {
    render: ({ state: { config, ...state } }) => {
      render(<Footer {...config} {...state} />, container);
    },
    destroy: () => {
      render(null, container);
    },
  };
};
